import React from "react"
import { slugify } from "/shared-utils/slugify"

const LinkableHeading = ({ level, children }) => {
  // Recursively flatten the children to a string
  const flattenChildren = children => {
    if (typeof children === "string") {
      return children
    }
    if (Array.isArray(children)) {
      return children.map(flattenChildren).join("")
    }
    if (typeof children === "object" && children !== null) {
      if ("props" in children && "children" in children.props) {
        return flattenChildren(children.props.children)
      }
    }
    return ""
  }

  const text = flattenChildren(children)

  const id = slugify(text)

  const Tag = `h${level}`

  return (
    <Tag id={id} className="linkable-heading">
      <a
        className="linkable-heading__anchor"
        href={`#${id}`}
        aria-label={`${text} permalink`}
      >
        <span>
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20.1862 1.82377C17.8718 -0.490636 14.1296 -0.523155 11.7753 1.75068L11.765 1.7608L10.045 3.4708C9.6533 3.86019 9.65145 4.49335 10.0408 4.88501C10.4302 5.27667 11.0634 5.27852 11.455 4.88913L13.1696 3.1845C14.7394 1.67341 17.2307 1.69666 18.772 3.23798C20.313 4.77897 20.3365 7.26946 18.8264 8.83933L15.8329 11.8329L15.8328 11.833C15.0123 12.6538 13.8757 13.0778 12.7181 12.9949C11.5605 12.9119 10.4959 12.3303 9.80076 11.401C9.46996 10.9587 8.84327 10.8684 8.40102 11.1992C7.95877 11.53 7.86843 12.1567 8.19923 12.5989C9.24198 13.993 10.8388 14.8654 12.5752 14.9897C14.3116 15.1141 16.0165 14.4782 17.2472 13.2469L20.2471 10.2471L20.2593 10.2347C22.5331 7.8804 22.5006 4.13817 20.1862 1.82377ZM9.42479 7.01022C7.68842 6.88586 5.98365 7.52177 4.7529 8.75289L1.7529 11.7529L1.74071 11.7653C-0.533119 14.1196 -0.5006 17.8618 1.8138 20.1762C4.12821 22.4906 7.87044 22.5231 10.2247 20.2493L10.2371 20.2371L11.9471 18.5271C12.3376 18.1366 12.3376 17.5034 11.9471 17.1129C11.5566 16.7224 10.9234 16.7224 10.5329 17.1129L8.82936 18.8164C7.2595 20.3265 4.76901 20.303 3.22802 18.762C1.68702 17.221 1.66346 14.7305 3.17359 13.1606L6.16724 10.167C6.98774 9.34617 8.1243 8.9222 9.28192 9.00511C10.4395 9.08802 11.5041 9.66962 12.1992 10.599C12.53 11.0412 13.1567 11.1316 13.599 10.8008C14.0412 10.47 14.1316 9.84327 13.8008 9.40102C12.758 8.00699 11.1612 7.13458 9.42479 7.01022Z"
              fill="#111111"
            />
          </svg>
        </span>
      </a>

      {children}
    </Tag>
  )
}

export default LinkableHeading
